import { Box, Container } from "@mui/material";
import OrdersTable from "../../components/orders/table";
import { columns } from "./data";
import { useAppDispatch } from "../../store/hooks";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getOrders } from "./async-actions";
import { OrdersSelectors } from "./selectors";

const Orders = () => {
   const dispatch = useAppDispatch();
   const orders = useSelector(OrdersSelectors.getOrdersList);
   const [selectedRowsCount, setSelectedRowsCount] = useState(0);
   const [packagesCount, setPackagesCount] = useState(0);

   const handleSelectedRowsCount = (selectedCount: any) => {
      setSelectedRowsCount(selectedCount);
   };

   useEffect(() => {
      dispatch(getOrders());
   }, []);
   return (
      <Container
         sx={{
            padding: "32px 0 120px 0",
         }}
      >
         <Box>
            <OrdersTable
               rows={orders}
               columns={columns}
               rowsSelectedCallback={handleSelectedRowsCount}
            />
         </Box>
      </Container>
   );
};

export default Orders;
